<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('scene.new_scene')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <gateway-selector v-model="mac" :rules="rulesGateway" :label="$t('scene.select_gateway')"></gateway-selector>
    <name-text-field v-model="nameText" :rules="rulesName"></name-text-field>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn :disabled="!validEditor" :loading="creating" flat color="primary" @click="create">{{ $t('scene.create') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import GatewaySelector from '@/components/gateway/GatewaySelector'

export default {
  name: 'SceneCreateorDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField,
    'gateway-selector': GatewaySelector
  },
  data() {
    return {
      mac: null,
      creating: false,
      validEditor: false,
      nameText: null,
      rulesName: [
        v => (v && !this.sceneNames.includes(v)) || this.$t('scene.name_should_not_be_duplicated')
      ],
      rulesGateway: [
        v => !!v || this.$t('scene.gateway_is_required')
      ]
    }
  },
  watch: {
    scenes(val) {
      if (this.creating) {
        let scene = val.find(s => s.title == this.nameText);
        if (scene) {
          this.$emit('create', `${this.mac}${this.nameText}`);
          this.visible = false;
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    scenes() {
      return this.userScene[this.mac] || [];
    },
    sceneNames() {
      return this.scenes.map(s => s.title);
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) return;
      this.creating = true;
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'jsonsetall',
          mac: this.mac,
          val: {
            scenes: [{
              title: this.nameText
            }]
          }
        });
      } catch (err) {
        this.$emit('toast', this.$t('scene.permission_denied'));
        this.creating = false;
        return;
      }
      await this.refreshMac(this.mac);
      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.creating = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.$refs.form.reset();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scene/SceneCreatorDialog.vue